import './styles.scss'
import { useSelector } from 'react-redux'
import { userSelector } from '../../redux/features/user/userSlice'
import ErrorBoundary from '../Shared/ErrorBoundary'
import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom'
import CreateListPage from '../User/Pages/CreateListPage'
import ViewListsPage from '../User/Pages/ViewListsPage'
import LoginPage from '../User/Pages/LoginPage'
import AuthenticationWrapper from '../User/Auth/AuthenticationWrapper'

const App = () => {
  const { isLoggedIn } = useSelector(userSelector)

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Routes>
          <Route element={<RequireAuth isLoggedIn={isLoggedIn}/>}>
            <Route exact path="/create-list" element={<CreateListPage/>}/>
            <Route exact path="/view-lists" element={<ViewListsPage/>}/>
          </Route>
          <Route exact path="/login" element={<LoginPage/>}/>
          <Route path="*" element={<Navigate replace to="/create-list"/>}/>
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  )
}

const RequireAuth = ({ isLoggedIn }) => {
  if (!isLoggedIn) {
    return <Navigate to="/login"/>
  }

  return <AuthenticationWrapper><Outlet/></AuthenticationWrapper>
}

export default App
